module.exports = __webpack_public_path__ + "static/img/join_us03.af8c8e16.jpg";